import $ from 'jquery';
import './shared/cookieHelper.js';
import './program/slider.min.js';
import { setCookie, getCookie } from './shared/cookieHelper';

window.GinitMapCO = function () {
    var map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 50.064192, lng: -130.605469 },
        zoom: 3
    });
    var card = document.getElementById('pac-card');
    var input = document.getElementById('pac-input');
    var countries = 'us';

    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    var autocomplete = new google.maps.places.Autocomplete(input);

    autocomplete.setComponentRestrictions(
        { 'country': ['us'] });

    autocomplete.setFields(
        ['address_components', 'geometry', 'icon', 'name']);

    var infowindow = new google.maps.InfoWindow();
    var infowindowContent = document.getElementById('infowindow-content');
    infowindow.setContent(infowindowContent);

    var iconBase = 'https://res.cloudinary.com/dvbdysuf5/image/upload/v1563789272/MakeItPossible/WebResources/';

    var marker = new google.maps.Marker({
        map: map,
        icon: iconBase + 'marker_map.png',
        anchorPoint: new google.maps.Point(0, -29)
    });

    autocomplete.addListener('place_changed', function () {
        infowindow.close();
        marker.setVisible(false);
        var place = autocomplete.getPlace();
        if (!place.geometry) {
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }

        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);  // Why 17? Because it looks good.
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);
        $("#btnConfirmAddress").removeAttr("disabled");
        var address = '';
        if (place.address_components) {
            address = [
                (place.address_components[0] && place.address_components[0].short_name || ''),
                (place.address_components[1] && place.address_components[1].short_name || ''),
                (place.address_components[2] && place.address_components[2].short_name || '')
            ].join(' ');
        }

        infowindowContent.children['place-icon'].src = place.icon;
        infowindowContent.children['place-name'].textContent = place.name;
        infowindowContent.children['place-address'].textContent = address;
        infowindow.open(map, marker);
    });
}

window.enableStepCO = function () {
    $("#form1").hide();
    var id = document.getElementById('pac-input').value;
    var add = encodeURIComponent(id);
    setCookie("AddressCO", add, 1);
    id = id.replace(/ /g, "+");
    var lat;
    var lng;
    var latlng;

    var url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + id + ",&key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E";
    console.log(url);
    $.getJSON(url, function (data, textStatus) {
        lat = data.results[0].geometry.location.lat;
        lng = data.results[0].geometry.location.lng;
        latlng = lat + ',' + lng;
        var url;
        var query;
        query = latlng
        url = "__id__";

        url = url.replace('__id__', query);
        window.location.href = url;
    });
}

window.HideAllQuestionsCO = function () {
    $("#form2").hide();
    $("#form3").hide();
    $("#notifybox").hide();
    $("#q1").hide();
    $("#notifyboxsuccess").hide();
}

window.showQ1CO = function () {
    var result = $("#hdnselectedOption").val();

    if (result == 'aboveplus' || result == 'above') {
        showResultCO();
    }
    else {
        $("#form2").hide();
        $("#result").hide();
        $("#q1").show();
    }
}

window.showResultCO = function () {
    $("#form2").hide();
    $("#q1").hide();
    $("#result").show();

    var result = $("#hdnselectedOption").val();

    if (result == 'under' || result=='between') {
        HideAllQuestionsCO();
        $("#answer").text('Congratulations!');
        $("#additionaltext").text('It looks like you may qualify for the CMG Community ONE program.');
        $("#notifybox").hide();
        $("#notifyboxSuccess").show();

        $.ajax({
            url: "/community-one/Qualify",
            type: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            data: "",
            success: function (response) {
            }
        });
    }

    if (result == 'aboveplus' || result == 'above') {
        HideAllQuestionsCO();
        $("#answer").html('Sorry, this program is not<br/> available based on your inputs');
        $("#additionaltext").text('But we may have other low down payment programs that could work!');

        $("#notifybox").show();
        $("#notifyboxSuccess").hide();
        $.ajax({
            url: "/community-one/NoQualify",

            type: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            data: "",
            success: function (response) {
            }
        });
    }
}

window.showResultCOFalse = function () {
    $("#form2").hide();
    $("#q1").hide();
    $("#result").show();

    HideAllQuestionsCO();
    $("#answer").html('Sorry, this program is not<br/> available based on your inputs');
    $("#additionaltext").text('But we may have other low down payment programs that could work!');

    $("#notifybox").show();
    $("#notifyboxSuccess").hide();
    $.ajax({
        url: "/community-one/NoQualifyDownPayment",

        type: 'POST',
        cache: false,
        contentType: false,
        processData: false,
        data: "",
        success: function (response) {
        }
    });
}

$(function () {
    if ($('#co_index_page').length) {
        $("#form1").show();
        $("#form2").hide();
        $("#result").hide();
        $("#notifybox").hide();
        $("#btnConfirmAddress").attr("disabled", "disabled");

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMapCO';
        script.async = true;
        document.body.appendChild(script);
    }

    if ($('#co_program_page').length) {
        $("#form2").show();

        $("#result").hide();
        $("#notifybox").hide();
        $("#notifyboxSuccess").hide();
        $("#q1").hide();
        $("#successResult").hide();
        $("#sorryResult").hide();
        $("#submitco").attr("disabled", "disabled");
        $("#submitco").css("background-color", "#E0E0E0");
        $("#submitSorry").attr("disabled", "disabled");
        $("#submitSorry").css("background-color", "#E0E0E0");
        var geocoder;
        var map;
        var address = getCookie("AddressCO");

        $(document).ready(function () {
            setCookie("VNCO", "");
            setCookie("VECO", "");
            setCookie("VPCO", "");
            $("#ex14").slider({
                ticks: [0, 1, 2, 3, 4],
                ticks_positions: [0, 25, 50, 75, 100],
                ticks_labels: ['', '', '', '', ''],
                ticks_snap_bounds: 1
            }).on('change', getValue);
        });

        $('#submitco').click(function () {
            var vemail = $("#txtEmail").val();
            if (!validateEmail1(vemail)) {
                $('#txtEmail').focus();
                alert("Invalid Email Address");
            }
            else {
                 var form = new FormData();
                form.append("name", $("#txtName").val());
                    form.append("email", $("#txtEmail").val());
                form.append("phone", $("#txtPhone").val());
                $("#successFormInput").hide();
                $("#successResult").show();
                $("#submitco").attr("disabled", "disabled");
                $("#submitco").css("background-color", "#E0E0E0");
                $.ajax({
                    url: "/community-one/submit-success",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    success: function (response) {
                    }
                });
            }
        });

        $('#submitSorry').click(function () {
            var vemail = $("#txtEmailSorry").val();
            if (!validateEmail1(vemail)) {
                $('#txtEmailSorry').focus();
                alert("Invalid Email Address");
            }
            else {
                var form = new FormData();
                form.append("name", $("#txtNameSorry").val());
                form.append("email", $("#txtEmailSorry").val());
                form.append("phone", $("#txtPhoneSorry").val());
                $("#sorryFormInput").hide();
                $("#sorryResult").show();
                $("#submitSorry").attr("disabled", "disabled");
                $("#submitSorry").css("background-color", "#E0E0E0");
                $.ajax({
                    url: "/community-one/submitSorry",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    success: function (response) {
                    }
                });
            }
        });

        $("#txtName").keyup(
            function () {
                var vname = $("#txtName").val();
                var vemail = $("#txtEmail").val();
                if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
                    $("#submitco").removeAttr("disabled");
                    $("#submitco").css("background-color", "#E5B900");
                    $("#signup").removeAttr("disabled");
                    $("#signup").css("background-color", "#E5B900");
                } else {
                    $("#submitco").attr("disabled", "disabled");
                    $("#submitco").css("background-color", "#E0E0E0");
                    $("#signup").attr("disabled", "disabled");
                    $("#signup").css("background-color", "#E0E0E0");
                }
                setCookie("VNCO", vname);
            }
        );
        $("#txtEmail").keyup(
            function () {
                var vname = $("#txtName").val();
                var vemail = $("#txtEmail").val();
                if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
                    $("#submitco").removeAttr("disabled");
                    $("#submitco").css("background-color", "#E5B900");
                    $("#signup").removeAttr("disabled");
                    $("#signup").css("background-color", "#E5B900");
                } else {
                    $("#submitco").attr("disabled", "disabled");
                    $("#submitco").css("background-color", "#E0E0E0");
                    $("#signup").attr("disabled", "disabled");
                    $("#signup").css("background-color", "#E0E0E0");
                }
                setCookie("VECO", vemail);
            }
        );
        $("#txtPhone").keyup(
            function () {
                var vphone = $("#txtPhone").val();
                setCookie("VPCO", vphone);
            }
        );

        $("#txtNameSorry").keyup(
            function () {
                var vname = $("#txtNameSorry").val();
                var vemail = $("#txtEmailSorry").val();
                if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
                    $("#submitco").removeAttr("disabled");
                    $("#submitco").css("background-color", "#E5B900");
                    $("#submitSorry").removeAttr("disabled");
                    $("#submitSorry").css("background-color", "#E5B900");
                } else {
                    $("#submitco").attr("disabled", "disabled");
                    $("#submitco").css("background-color", "#E0E0E0");
                    $("#submitSorry").attr("disabled", "disabled");
                    $("#submitSorry").css("background-color", "#E0E0E0");
                }
                setCookie("VNCO", vname);
            }
        );
        $("#txtEmailSorry").keyup(
            function () {
                var vname = $("#txtNameSorry").val();
                var vemail = $("#txtEmailSorry").val();
                if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
                    $("#submitco").removeAttr("disabled");
                    $("#submitco").css("background-color", "#E5B900");
                    $("#submitSorry").removeAttr("disabled");
                    $("#submitSorry").css("background-color", "#E5B900");
                } else {
                    $("#submitco").attr("disabled", "disabled");
                    $("#submitco").css("background-color", "#E0E0E0");
                    $("#submitSorry").attr("disabled", "disabled");
                    $("#submitSorry").css("background-color", "#E0E0E0");
                }
                setCookie("VECO", vemail);
            }
        );
        $("#txtPhoneSorry").keyup(
            function () {
                var vphone = $("#txtPhoneSorry").val();
                setCookie("VPCO", vphone);
            }
        );
    }

    if ($('#co_info_page').length) {
        $("#notifybox").show();
        $("#sorryResult").hide();
        $("#submitSorry").attr("disabled", "disabled");
        $("#submitSorry").css("background-color", "#E0E0E0");
        var geocoder;
        var map;
        var address = getCookie("AddressCO");

        $("#txtNameSorry").keyup(
            function () {
                var vname = $("#txtNameSorry").val();
                var vemail = $("#txtEmailSorry").val();
                if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
                    $("#submitco").removeAttr("disabled");
                    $("#submitco").css("background-color", "#E5B900");
                    $("#submitSorry").removeAttr("disabled");
                    $("#submitSorry").css("background-color", "#E5B900");
                } else {
                    $("#submitco").attr("disabled", "disabled");
                    $("#submitco").css("background-color", "#E0E0E0");
                    $("#submitSorry").attr("disabled", "disabled");
                    $("#submitSorry").css("background-color", "#E0E0E0");
                }
                setCookie("VNCO", vname);
            }
        );
        $("#txtEmailSorry").keyup(
            function () {
                var vname = $("#txtNameSorry").val();
                var vemail = $("#txtEmailSorry").val();
                if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
                    $("#submitco").removeAttr("disabled");
                    $("#submitco").css("background-color", "#E5B900");
                    $("#submitSorry").removeAttr("disabled");
                    $("#submitSorry").css("background-color", "#E5B900");
                } else {
                    $("#submitco").attr("disabled", "disabled");
                    $("#submitco").css("background-color", "#E0E0E0");
                    $("#submitSorry").attr("disabled", "disabled");
                    $("#submitSorry").css("background-color", "#E0E0E0");
                }
                setCookie("VECO", vemail);
            }
        );
        $("#txtPhoneSorry").keyup(
            function () {
                var vphone = $("#txtPhoneSorry").val();
                setCookie("VPCO", vphone);
            }
        );

        $('#submitSorry').click(function () {
            var vemail = $("#txtEmailSorry").val();
            if (!validateEmail1(vemail)) {
                $('#txtEmailSorry').focus();
                alert("Invalid Email Address");
            }
            else {
                var form = new FormData();
                form.append("name", $("#txtNameSorry").val());
                form.append("email", $("#txtEmailSorry").val());
                form.append("phone", $("#txtPhoneSorry").val());
                $("#sorryFormInput").hide();
                $("#sorryResult").show();
                $("#submitSorry").attr("disabled", "disabled");
                $("#submitSorry").css("background-color", "#E0E0E0");
                $.ajax({
                    url: "/community-one/submitSorry",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    success: function (response) {
                    }
                });
            }
        });
    }

    function getValue() {
        var sliderValue = $("#ex14").val();
        if (sliderValue == 0) {
            $('#hdnselectedOption').val("no");
            $('#hdnGrantAmt').val("0");
            var value = "Please select your income level";
            $('#selectedtext').text(value);
            $("#continue").attr("disabled", "disabled");
            $("#continue").css("background-color", "#92B9D1");
        }
        else {
            $("#continue").removeAttr("disabled");
            $("#continue").css("background-color", "#2775A3");
        }
        if (sliderValue == 1) {
            $('#hdnselectedOption').val("under");
            $('#hdnGrantAmt').val($('#hdnUnderAmt').val());
            var value = "Less than $" + getCookie("amihalfco");
            $('#selectedtext').text(value.replace(/%2C/g, ","));
        }

        if (sliderValue == 2) {
            $('#hdnselectedOption').val("between");
            $('#hdnGrantAmt').val($('#hdnBetweenAmt').val());
            var value = "Between $" + getCookie("amihalfco") + " and $" + getCookie("amico");
            $('#selectedtext').text(value.replace(/%2C/g, ","));
        }

        if (sliderValue == 3) {
            $('#hdnselectedOption').val("above");
            $('#hdnGrantAmt').val($('#hdnAboveAmt').val());
            var value = "Between $" + getCookie("amico") + " and  $" + getCookie("amifullco");
            $('#selectedtext').text(value.replace(/%2C/g, ","));
        }

        if (sliderValue == 4) {
            $('#hdnselectedOption').val("aboveplus");
            $('#hdnGrantAmt').val($('#hdnAbovePlusAmt').val());
            var value = "Over $" + getCookie("amifullco");
            $('#selectedtext').text(value.replace(/%2C/g, ","));
        }
    }

    function validateEmail1(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
});
